


import React, { useState, useEffect, useRef } from "react";
import { format, isSameDay } from "date-fns";
import DatePicker from "react-datepicker";
import './PmAttendanceReport.css'
import { sameDatesAttendanceForItmReport, } from "../../../../services/dashboard";
import { pmWiseAttendaceSameDates, pmWiseAttendaceDifferentDAte, zoneWiseAttendaceSameDates, zoneWiseEmployeeLevelByDate, zoneWiseAttendaceDifferentDAte } from "../../../../services/dashboardReports";
import { handleSortByTime } from "../../../../utils/sortingOrderByTime";
import { capitalizeFirstLetter, convertToIST } from "../../../../utils/validations";

const StateAttendanceReport = () => {
    const today = new Date();

    /* ---------- Core state ---------- */
    const [fromDate, setFromDate] = useState(today);
    const [toDate, setToDate] = useState(today);
    const [sameDayAttendance, setSameDayAttendance] = useState(null);   // original payload
    const [differenceDayAttendace, setDifferenceDayAttendance] = useState();
    //const zoneName = localStorage.getItem("zoneName");
    // const zoneId = localStorage.getItem("zoneId");
    const stateId = localStorage.getItem("stateId")
    const employeeUniqueId = localStorage.getItem('employeeUniqueIdLogin');
    const [districtId, setDistrictId] = useState(null);
    const [districtsTable, setDistrictsTable] = useState('');
    const [districtName, setDistrictName] = useState();
    const [userData, setUSerData] = useState([]);
    /* ---------- Filter state ---------- */
    const [displayMode, setDisplayMode] = useState("all"); // all | present | absent | notInLocation
    const [filteredRecords, setFilteredRecords] = useState([]); // what the table renders
    const [filterLoading, setFilterLoading] = useState(false);
    const [filterError, setFilterError] = useState(null);
    const [filterTitle, setFilterTitle] = useState("");
    const [zoneId, setZoneId] = useState(null);
    const [zoneName, setZoneName] = useState();
    const [selectedDate, setSelectedDate] = useState(null);
    const [employeeTable, setEmployeeTable] = useState([]);
    const [employeeLevelVisible, setEmployeeLevelVisible] = useState(false);
    const [districtLevelVisible, setDistrictLevelVisible] = useState(false)
    const [sortOrder, setSortOrder] = useState("asc"); // or null initially

    const [zoneLoading, setZoneLoading] = useState(false);
    const [districtLoading, setDistrictLoading] = useState(false);
    const [employeeLoading, setEmployeeLoading] = useState(false);


    /* ---------- Load original attendance (same day / range) ---------- */
    useEffect(() => {
        const fetchAttendance = async () => {
            setFilterLoading(true);
            setFilteredRecords([]);

            // ✅ Reset all drill-down states when dates change
            setDistrictLevelVisible(false);
            setEmployeeLevelVisible(false);
            setSelectedDate(null);
            setZoneName(null);
            setDistrictName(null);
            setDistrictsTable([]);
            setEmployeeTable([]);
            setZoneLoading(false);
            setEmployeeLoading(false);

            try {
                const same = isSameDay(fromDate, toDate);

                if (same) {
                    const data = await pmWiseAttendaceSameDates(fromDate, toDate);
                    setSameDayAttendance(data);
                    setFilteredRecords(data || []);
                } else {
                    const data = await pmWiseAttendaceDifferentDAte(stateId, fromDate, toDate);
                    setDifferenceDayAttendance(data);
                    setSameDayAttendance(null);
                }
            } catch (e) {
                console.error(e);
                setFilterError("Failed to load data");
            } finally {
                setFilterLoading(false);
            }
        };

        fetchAttendance();
    }, [fromDate, toDate]);
    const handleRowClick = async (rowDate) => {
        const clickedDate = new Date(rowDate);

        if (isNaN(clickedDate.getTime())) {
            console.error("Invalid date received:", rowDate);
            return;
        }

        setSelectedDate(clickedDate);
        setFilterLoading(true);

        // ✅ Reset all drill-down states
        setDistrictLevelVisible(false);
        setEmployeeLevelVisible(false);
        setZoneName(null);
        setDistrictName(null);
        setDistrictsTable([]);
        setEmployeeTable([]);
        setZoneLoading(false);
        setEmployeeLoading(false);

        try {
            const data = await pmWiseAttendaceSameDates(clickedDate, clickedDate);
            setFilteredRecords(data || []);
        } catch (err) {
            console.error("Error fetching zones:", err);
            setFilterError("Failed to load zone data");
        } finally {
            setFilterLoading(false);
        }
    };

    const handleZoneClick = async (id, name) => {
        setZoneLoading(true);
        setZoneName(name);
        setDistrictLevelVisible(true);
        setEmployeeLevelVisible(false);

        // ✅ Clear employee data when clicking new zone
        setEmployeeTable([]);
        setDistrictName(null);

        try {
            let dateToUse = selectedDate ? new Date(selectedDate) : new Date(fromDate);
            const data = await zoneWiseAttendaceSameDates(id, dateToUse, dateToUse);
            setDistrictsTable(data);
            setFilterTitle(`Zone - ${name}`);
        } catch (err) {
            setFilterError("Failed to load district data");
            setDistrictLevelVisible(false);
        } finally {
            setZoneLoading(false);
        }
    };
    const handleDistrictClick = async (id, name) => {
        setEmployeeLoading(true);
        setDistrictName(name);
        setEmployeeLevelVisible(true);  // ✅ Show immediately

        try {
            const data = await sameDatesAttendanceForItmReport(id, selectedDate || fromDate, selectedDate || fromDate);
            setEmployeeTable(data);
        } catch (err) {
            setFilterError("Failed to load employee data");
            setEmployeeLevelVisible(false); // Optional: hide on error
        } finally {
            setEmployeeLoading(false);
        }
    };


    const handleBackToDistrict = () => {
        setEmployeeLevelVisible(false);
    };





    /* ---------- Table rows ---------- */
    const renderSameDayRows = () => {
        if (filterLoading) {
            return <tr><td colSpan={6} className="text-center">Loading zones data...</td></tr>;
        }

        if (filterError) return <tr><td colSpan={6} className="text-center text-danger">{filterError}</td></tr>;
        if (!filteredRecords.length) return <tr><td colSpan={6} className="text-center">No data</td></tr>;

        return filteredRecords.map((r, i) => (
            <tr key={i} onClick={() => handleZoneClick(r.zoneId, r.zoneName)}>
                <td>{i + 1}</td>
                <td className="text-start">{r.zoneName ?? "-"}</td>
                <td>{r.totalEmployeesCount}</td>
                <td>{r.presentCount ?? "-"}</td>
                <td>{r.leaveCount }</td>
                <td>{r.absentCount}</td>
            </tr>
        ));
    };

    const renderSelectedDateZones = () => {
        return filteredRecords.map((r, i) => (
            <tr key={i} onClick={() => handleZoneClick(r.zoneId, r.zoneName)}>
                <td>{i + 1}</td>
                <td>{r.zoneName}</td>
                <td>{r.totalEmployeesCount}</td>
                <td>{r.presentCount}</td>
                <td>{r.leaveCount}</td>
                <td>{r.absentCount }</td>
            </tr>
        ));
    };

    return (
        <div className="pm-dashboard-page-repo">
            <div className="pm-new-dashboard-dash-repo">
                <div className="pm-current-month-date-dash-repo">
                    <h2>Attendance Report</h2>
                </div>


                <div className="pm-dates-repo">
                    {/* <div className="pm-container-part-repo"><div className="pm-districtzone">Zone Attendance - {zoneName}</div></div> */}
                    <div className="pm-container-part-repo">
                        <div className={`pm-floating-label-container-1-repo ${fromDate ? "filled" : ""}`}>
                            <DatePicker selected={fromDate} onChange={setFromDate} dateFormat="dd-MM-yyyy" maxDate={today} placeholderText=" " />
                            <label>From Date</label>
                        </div>
                    </div>
                    <div className="pm-container-part-repo">
                        <div className={`pm-floating-label-container-1-repo ${toDate ? "filled" : ""}`}>
                            <DatePicker selected={toDate} onChange={setToDate} dateFormat="dd-MM-yyyy" minDate={fromDate} maxDate={today} placeholderText=" " />
                            <label>To Date</label>
                        </div>
                    </div>
                </div>
                {isSameDay(fromDate, toDate) && (
                    <>

                        <div className="pm-table-for-emp-repo ">
                            <table className="pm-table-dash-repo ">
                                <thead className="pm-table-head-dash-repo">
                                    <tr>
                                        <th>S.No</th>
                                        <th>Zone </th>
                                        <th>Total No. of Employees</th>
                                        <th>No.of Employee Present </th>
                                        <th>No.of Employee on Leave </th>
                                        <th>No.of Employee Absent </th>
                                    </tr>
                                </thead>
                                <tbody className="table-body-dash-repo">{renderSameDayRows()}</tbody>



                            </table>
                        </div>
                    </>
                )}
                {!isSameDay(fromDate, toDate) && (
                    <div className="border rounded-2 mt-5 thick-border">
                        <table className="mx-auto my-3">
                            <thead className="itm-table-head-dash-repo">
                                <tr>
                                    <th>S.No</th>
                                    <th>Date</th>
                                    <th>Total No. of Employees</th>
                                    <th>No. of Employees Present</th>
                                    <th>No. of Employees on Leave</th>
                                    <th>No. of Employees Absent</th>
                                </tr>
                            </thead>
                            <tbody className="table-body-dash-repo" style={{ cursor: "pointer" }}>
                                {filterLoading ? (
                                    <tr>
                                        <td colSpan="6" style={{ textAlign: 'center', padding: '1rem' }}>
                                            Loading attendance data...
                                        </td>
                                    </tr>
                                ) : differenceDayAttendace?.length > 0 ? (
                                    differenceDayAttendace.map((record, index) => (
                                        <tr key={index} onClick={() => handleRowClick(record.date)}>
                                            <td>{index + 1}</td>
                                            <td>{format(record.date, 'dd-MM-yyyy') || "-"}</td>
                                            <td>{record.totalEmployeesCount}</td>
                                            <td>{record.presentCount || "-"}</td>
                                            <td>{record.leaveCount}</td>
                                            <td>{record.absentCount}</td>

                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="6" style={{ textAlign: 'center', padding: '1rem' }}>
                                            No attendance data available.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                )}

                {selectedDate && !isSameDay(fromDate, toDate) && (
                    <>
                        <div className="mt-5">
                            <h3>Zones data for the date - {format(selectedDate, 'dd-MM-yyyy')}</h3>
                            <div className="pm-table-for-emp-repo ">
                                <table className="pm-table-dash-repo ">
                                    <thead className="pm-table-head-dash-repo">
                                        <tr>
                                            <th>S.No</th>
                                            <th>Zone </th>
                                            <th>Total No. of Employees</th>
                                            <th>No.of Employee Present </th>
                                            <th>No.of Employee on Leave </th>
                                            <th>No.of Employee Absent </th>
                                        </tr>
                                    </thead>
                                    <tbody className="table-body-dash-repo">{renderSelectedDateZones()}</tbody>
                                </table>
                            </div>
                        </div>

                    </>
                )}

                {districtLevelVisible && (
                    <>
                        <div className="mt-5">
                            <h3>District data for the date - {zoneName}</h3>
                            <div className="pm-table-for-emp-repo ">
                                <table className="pm-table-dash-repo ">
                                    <thead className="pm-table-head-dash-repo">
                                        <tr>
                                            <th>S.No</th>
                                            <th>District </th>
                                            <th>Total No. of Employees</th>
                                            <th>No.of Employee Present </th>
                                            <th>No.of Employee on Leave </th>
                                            <th>No.of Employee Absent </th>
                                        </tr>
                                    </thead>
                                    <tbody className="table-body-dash-repo">
                                        {/* ✅ Add loading check here */}
                                        {zoneLoading ? (
                                            <tr>
                                                <td colSpan={6} className="text-center">Loading district data...</td>
                                            </tr>
                                        ) : districtsTable?.length > 0 ? (
                                            districtsTable.map((r, i) => (
                                                <tr key={i} onClick={() => handleDistrictClick(r.districtId, r.districtName)}>
                                                    <td>{i + 1}</td>
                                                    <td className="text-start">{r.districtName ?? "-"}</td>
                                                    <td>{r.totalEmployeeCount}</td>
                                                    <td>{r.presentCount ?? "-"}</td>
                                                    <td>{r.leaveCount}</td>
                                                    <td>{r.absentCount}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={6} className="text-center">No Data</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </>
                )}

                {employeeLevelVisible && (
                    <>
                        <button className="btn btn-secondary mt-5" onClick={handleBackToDistrict}>Back</button>

                        <h3>Employee Attendance for {zoneName} -{districtName}- {format(selectedDate || fromDate, "dd-MM-yyyy")}</h3>
                        <div className="border rounded-2 thick-border">
                            <table className="pm-table-dash-repo-emp mt-3">
                                <thead className="pm-table-head-dash-repo">
                                    <tr>
                                        <th>S.No</th>
                                        <th>Employee Name</th>
                                        <th>Designation</th>
                                        <th>Working Location</th>
                                        <th>Mobile Number</th>
                                        <th>Attendance Status</th>
                                        <th
                                            onClick={() =>
                                                handleSortByTime(sortOrder, setSortOrder, employeeTable, setEmployeeTable)
                                            }
                                            style={{ cursor: "pointer" }}
                                        >
                                            Attendance Time {sortOrder === "asc" ? "▲" : "▼"}
                                        </th>
                                        <th>Location Status</th>
                                        <th>Remarks</th>
                                        <th> Distance Reason</th>
                                        <th>Attendance Photo</th>
                                    </tr>
                                </thead>

                                <tbody className="table-body-dash-repo-pm ">
                                    {/* ✅ Add loading check here */}
                                    {employeeLoading ? (
                                        <tr>
                                            <td colSpan={10} className="text-center">Loading employee data...</td>
                                        </tr>
                                    ) : employeeTable?.records?.length > 0 ? (
                                        employeeTable?.records.map((emp, i) => (
                                            <tr key={i}>
                                                <td>{i + 1}</td>
                                                <td className="text-start">{emp.employeeName ?? "-"}</td>
                                                <td>{emp.designation ?? "-"}</td>
                                                <td>{emp.isWorkLocation === true ? (emp.workLocationName?.trim() || "-") : (emp.godownName?.trim() || "-")}</td>
                                                <td>{emp.contactNumber ?? "-"}</td>
                                                <td>{emp.attendanceStatus==="Not Marked" ?"Absent": emp.attendanceStatus}</td>
                                                <td>{emp.attendanceTime ? convertToIST(emp.attendanceDate, emp.attendanceTime) : "-"}</td>
                                                <td>{emp.attendanceStatus === "Present" ? (emp.remarks === null || emp.remarks === "" ||emp.remarks==="null" || emp.remarks==="Inside the godown" ? "In the location" : "Not in the location") : "-"}</td>
                                                <td>{emp.remarks==="null"||emp.remarks==="Inside the godown"||emp.remarks === null ||  emp.remarks === ""  ?"-": emp.remarks??"-"}</td>
                                                <td>{capitalizeFirstLetter(emp.distanceReason )|| "-"}</td>
                                                <td>
                                                    <span className="employee-selfie">{emp?.selfieUrl ? (
                                                        <a
                                                            href={emp.selfieUrl.startsWith("http")
                                                                ? emp.selfieUrl
                                                                : `${process.env.REACT_APP_FILE_BASE_URL}/${emp.selfieUrl}`}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            View
                                                        </a>
                                                    ) : (
                                                        "-"
                                                    )}</span>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={10} className="text-center">No Employee Data</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}



            </div>
        </div >
    );
};

export default StateAttendanceReport;